module.exports = __webpack_public_path__ + "img/logo.bc11fe0e.svg";